<script>
  import { getContext } from "svelte";
  const { errors } = getContext("form");
  // import Error from "./Error.svelte";
  import ErrorSlot from "./ErrorSlot.svelte";
  // const { rules } = getContext("form");

  export let label;
  export let subLabel = "";
  export let required = false;
  export let name = "";
  export let slim = false;
  // const fieldRules = (name && rules[name]?.validators.map((v) => v.name)) || [];
  // console.log(rules, fieldRules);
  let wrapperClasses = slim ? "mt-1 relative" : "w-full mt-1 relative";
</script>

<div class={wrapperClasses}>
  {#if label}
    <div class="flex mb-1">
      <label for={name} class="grow strong w-full text-sm font-medium">
        {label} <small class="text-gray-500"> {subLabel || ""}</small>
        {#if required}
          <span class="text-red-500">*</span>
        {/if}
      </label>
    </div>
  {/if}
  <!-- select goes here -->
  <slot />
  <!-- {#each fieldRules as rule}
    <Error fieldName={name} errorKey={rule} />
  {/each} -->
  {#if $errors && name}
    <ErrorSlot errors={$errors} fieldName={name} />
  {/if}
</div>
